import React, { useState } from 'react';
import { AgGridReact } from "ag-grid-react";

export const Index = () => {
    const [activeTab, setActiveTab] = useState("SPDR");

    const handleTabChange = (eventKey) => {
        setActiveTab(eventKey);
    };
    const columnDefs = [
        {
            headerName: 'Indices',
            field: 'name'
        },
        { headerName: 'MTD%', field: 'mtd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" },
        { headerName: 'QTD', field: 'qtd', editable: false,cellStyle: { textAlign: "right" } ,headerClass: "text-end"},
        { headerName: 'YTD', field: 'ytd', editable: false,cellStyle: { textAlign: "right" },headerClass: "text-end" }

    ];
    const indicesdt = [{
        "name": "SPDR S&P 500 ETF Trust (SPY)",
        "mtd": 0.20,
        "qtd": 4.74,
        "ytd": 27.43
    },
    {
        "name": "iShares MSCI India ETF (INDA)",
        "mtd": -1.05,
        "qtd": -9.30,
        "ytd": 10.24
    },
    {
        "name": "iShares Russell 2000 ETF (IWM)",
        "mtd": -3.62,
        "qtd": 0.80,
        "ytd": 12.54
    },
    {
        "name": "Vanguard FTSE Emerging Markets ETF (VWO)",
        "mtd": -0.19,
        "qtd": 0.40,
        "ytd": 12.54
    },
    {
        "name": "iShares MSCI EAFE ETF (EFA)",
        "mtd": -1.45,
        "qtd": -7.48,
        "ytd": 3.85
    }];
    const defaultDef = {
        flex: 1,
        minWidth: 150,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: true,
        cellDataType: false,
        resizable:true
    };


    return (
        <>              
                <div className="container mt-5">
                    <h5 style={{ color: '#037196' }}> Top 5 Performing Indices</h5>
                    <div
                        className="ag-theme-alpine"
                        style={{ height: "50vh", width: "100%" }}
                    >
                        <AgGridReact
                            rowData={indicesdt}
                            columnDefs={columnDefs}
                            defaultColDef={defaultDef}

                        />
                    </div>
                
              
            </div>
                     
        </>
    )
}